module.exports = __webpack_public_path__ + "static/media/a2i.4d64abc9.webp";